import { last, first, assign, uniqueId } from 'lodash-es'

import DROP_MARKER from './gallery-properties.flow.drop-marker'

export default Flow
export const signValueCast       = Sign(uniqueId('VALUE_CAST'))
export const signOverrideByKey   = Sign(uniqueId('OVERRIDE_BY_KEY'))
export const signOverrideByEnv   = Sign(uniqueId('OVERRIDE_BY_ENV'))
export const signOverrideByConst = Sign(uniqueId('OVERRIDE_BY_CONST'))
export const signFallbackToEnv   = Sign(uniqueId('FALLBACK_TO_ENV'))
export const signFallbackToKey   = Sign(uniqueId('FALLBACK_TO_KEY'))
export const signFeatureCheck    = Sign(uniqueId('FEATURE_CHECK'))
export const signUserFunction    = Sign(uniqueId('USER_FUNCTION'))
export const signFallbackToConst = Sign(uniqueId('FALLBACK_TO_CONST'))

function Sign(type) {
  return function sign(func) {
    return assign(func, { type })
  }
}

function Flow(...funcs) {
  return flow

  function flow(result, calcProp) {
    for (let index = 0; index !== funcs.length; index++) {
      const func = funcs[index]
      result = func(result, calcProp)
      if (result === DROP_MARKER) result = null
    }

    const fallback = last(funcs)
    const cast = first(funcs)
    result = fallback(cast(result, calcProp), calcProp)
    if (result === DROP_MARKER) result = null

    return result
  }
}
